export default "__VITE_ASSET__Bbk4ydW1__"